// extracted by mini-css-extract-plugin
module.exports = {"main":"RichText_main__302Ei","dark":"RichText_dark__djpzF"};